import { administrationRequests } from "api/administrationApi";
import ScheduledItemsGrid from "./ScheduledItemsGrid";

const InternshipsGrid = props => (
  <ScheduledItemsGrid
    {...props}
    source="internshipId"
    reference={administrationRequests.getInternshipsSelect()}
    label="Стаж"
  />
);

export default InternshipsGrid;
